export type AuditAssetsUpload = {
  id: string | null;
  uploadedAssetId: string;
  url: string;
};
